export const FAN_NUMBERING_MIN = 2
export const FAN_NUMBERING_MAX = 9
